
import Vue from "vue";
import { mapState } from "vuex";

type OssMap = Record<string, string>;

const ProductGallery = Vue.extend({
  functional: true,
  props: { title: String, hero: String, groups: Array, resolve: Function },
  render(h, { props }) {
    const rows = (props.groups as Array<{
      label: string;
      images: string[];
    }>).map(group =>
      h("div", { key: group.label, class: "gallery-group" }, [
        h("h4", { class: "gallery-label" }, [group.label]),
        h(
          "div",
          { class: "gallery-grid" },
          group.images.map(image =>
            h("img", {
              key: image,
              class: "image",
              attrs: { src: props.resolve(image), alt: group.label }
            })
          )
        )
      ])
    );
    return h("div", { class: "gallery" }, [
      h("div", { class: "section-heading gallery-heading" }, [
        h("h3", { class: "gallery-title" }, [props.title])
      ]),
      h("img", {
        class: "image gallery-hero",
        attrs: { src: props.resolve(props.hero), alt: props.title }
      }),
      rows
    ]);
  }
});

export default Vue.extend({
  components: { ProductGallery },
  data() {
    return {
      prescriptionImages: [
        "am_real_open_ghost_09_rx_01",
        "am_real_open_ghost_09_rx_02",
        "am_real_open_ghost_09_rx_03"
      ]
    };
  },
  computed: {
    ...mapState("app", { isCN: "isCN", isMobile: "isMobile" }),
    ...mapState("assets", { oss: "oss" }),
    kvImageKey(): string {
      const locale = this.isCN ? "cn" : "en";
      return `am_real_open_ghost_01_kv${
        this.isMobile ? "_mobile" : ""
      }_${locale}`;
    },
    tryOnGlassesUrl(): string {
      return `https://www.angrymiao.com/${
        this.isCN ? "cn" : "en"
      }/am-real-open-ghost/tryonglasses`;
    },
    modelRGroups() {
      const label = (key: string) =>
        String(this.$t(`AMRealOpenGhost.gallery.${key}`));
      return [
        {
          label: label("modelRAmber"),
          images: [
            "am_real_open_ghost_13_model_r_amber_01",
            "am_real_open_ghost_13_model_r_amber_02",
            "am_real_open_ghost_13_model_r_amber_03"
          ]
        },
        {
          label: label("modelRTortoise"),
          images: [
            "am_real_open_ghost_14_model_r_tortoise_01",
            "am_real_open_ghost_14_model_r_tortoise_02",
            "am_real_open_ghost_14_model_r_tortoise_03"
          ]
        },
        {
          label: label("modelRGray"),
          images: [
            "am_real_open_ghost_15_model_r_gray_01",
            "am_real_open_ghost_15_model_r_gray_02",
            "am_real_open_ghost_15_model_r_gray_03"
          ]
        }
      ];
    },
    modelSGroups() {
      const label = (key: string) =>
        String(this.$t(`AMRealOpenGhost.gallery.${key}`));
      return [
        {
          label: label("modelSGray"),
          images: [
            "am_real_open_ghost_17_model_s_gray_01",
            "am_real_open_ghost_17_model_s_gray_02",
            "am_real_open_ghost_17_model_s_gray_03"
          ]
        },
        {
          label: label("modelSDeepGreen"),
          images: [
            "am_real_open_ghost_18_model_s_deep_green_01",
            "am_real_open_ghost_18_model_s_deep_green_02",
            "am_real_open_ghost_18_model_s_deep_green_03"
          ]
        },
        {
          label: label("modelSWhite"),
          images: [
            "am_real_open_ghost_19_model_s_white_01",
            "am_real_open_ghost_19_model_s_white_02",
            "am_real_open_ghost_19_model_s_white_03"
          ]
        }
      ];
    }
  },
  methods: {
    resolveImage(key: string): string {
      const assets = this.oss as OssMap;
      const mobileKey = `${key}_mobile`;
      return this.isMobile
        ? assets[mobileKey] || assets[key] || ""
        : assets[key] || "";
    },
    onVerify() {
      window.open(this.$paths.verify + "cyberboard/", "_blank");
    }
  }
});
